import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { APP_LINKS, NAV_LINKS } from "../../constants/site";
import { Icon } from "./Icon";
import { Logo } from "./Shared";

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-teal-deep/10 bg-paper/90 backdrop-blur-md">
      <div className="container-site flex h-[72px] items-center justify-between">
        <Link to="/" aria-label="HomeAligns home" data-testid="nav-home-link">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors duration-200 ${
                  isActive ? "text-teal-deep" : "text-ink/60 hover:text-teal-deep"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={APP_LINKS.login}
            data-testid="nav-login-btn"
            className="rounded-full px-5 py-2.5 text-sm font-bold text-teal-deep transition-colors duration-200 hover:bg-teal-mist"
          >
            Log In
          </a>
          <a href={APP_LINKS.getStarted} data-testid="nav-get-started-btn" className="btn-primary !px-6 !py-2.5">
            Get Started
            <Icon name="ArrowRight" className="h-4 w-4" />
          </a>
        </div>

        <button
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-mobile-menu-btn"
          onClick={() => setOpen((v) => !v)}
          className="flex h-11 w-11 items-center justify-center rounded-xl border border-teal-deep/15 text-teal-deep lg:hidden"
        >
          <Icon name={open ? "X" : "Menu"} className="h-5 w-5" />
        </button>
      </div>

      {open && (
        <div className="border-t border-teal-deep/10 bg-paper lg:hidden" data-testid="nav-mobile-panel">
          <nav className="container-site flex flex-col gap-1 py-4" aria-label="Mobile">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className="rounded-xl px-4 py-3 text-sm font-semibold text-ink/70 hover:bg-teal-mist hover:text-teal-deep"
              >
                {l.label}
              </NavLink>
            ))}
            <div className="mt-3 flex flex-col gap-2 border-t border-teal-deep/10 pt-4">
              <a
                href={APP_LINKS.login}
                data-testid="nav-mobile-login-btn"
                className="btn-secondary w-full !py-3"
              >
                Log In
              </a>
              <a
                href={APP_LINKS.getStarted}
                data-testid="nav-mobile-get-started-btn"
                className="btn-primary w-full !py-3"
              >
                Get Started
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
